<section class="modern-section modern-testimonial dingo-bg-brand-glow">
  <div class="container">
    <article class="testimonial-neon-card reveal-on-scroll" data-reveal="card">
      <span class="testimonial-quote testimonial-quote--left" aria-hidden="true">“</span>
      <p class="testimonial-neon-text">
        “Grupo Dingo logró conectar estrategia, creatividad y ejecución bajo un mismo sistema de crecimiento. Su enfoque
        omnicanal permitió mejorar visibilidad, fortalecer posicionamiento y generar resultados medibles alineados a
        objetivos comerciales.”
      </p>
      <span class="testimonial-quote testimonial-quote--right" aria-hidden="true">”</span>

      <div class="testimonial-orb" aria-hidden="true">
        <span class="testimonial-orb-ring"></span>
      </div>
    </article>
  </div>
</section>
